import { redirect } from 'react-router-dom';
import { authGuard } from '@/middleware/auth-guard.ts';
import { Member  } from '@/models';
import { getCurrentUser } from '@/stores/auth-store.ts';

/**
 * @experimental
 * @param loader
 */
export const withMemberGuard = <T = unknown>(
  loader: (args: any) => Promise<T>
) => {
  return async (args: any): Promise<T> => {
    await authGuard();

    const currentUser = getCurrentUser();
    if (!currentUser) {
      throw redirect('/auth/login');
    }

    const response = await loader(args);

    const serverData = response as { server: { members: Member[] } };

    const isMember = serverData.server.members.some(
      (member) => member.profileId === currentUser.id
    );

    if (!isMember) {
      throw redirect('/');
    }

    return response;
  };
};
